<template>
  <div :style="nodeMargin">
    <div @click="toggleChildren" show class="d-flex mb-1">
      {{ name }}

      <b-icon
        class="align-self-center"
        v-if="hasChildren"
        :icon="toggleChildrenIcon"
      ></b-icon>
    </div>
    <div v-if="hasChildren" v-show="showChildren">
      <TreeNode
        v-for="key in Object.keys(node)"
        ref="children"
        :key="key"
        :name="key"
        :node="node[key]"
        :spacing="spacing + 10"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    spacing: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showChildren: false,
    };
  },
  computed: {
    nodeMargin() {
      return {
        'margin-left': `${this.spacing}px`,
      };
    },
    hasChildren() {
      return Object.keys(this.node).length > 0;
    },
    toggleChildrenIcon() {
      return this.showChildren ? 'caret-down' : 'caret-right';
    },
  },
  methods: {
    toggleChildren() {
      this.showChildren = !this.showChildren;
    },
    toggleAll(visibility) {
      this.showChildren = visibility;
      const children = this.$refs.children;
      if (children)
        this.$refs.children.forEach((child) => {
          child.toggleAll(this.showChildren);
        });
    },
  },
};
</script>
